import { useMemo } from 'react';
import { useProjectStore } from '../store/project-store';
import { ensureDefaultStates } from '@shared/core/defaults';
function useProjectStates(projectId) {
    const projects = useProjectStore((s) => s.projects);
    return useMemo(() => {
        if (!projectId)
            return ensureDefaultStates();
        const project = projects.find((p) => p.project_id === projectId);
        return ensureDefaultStates(project?.config.states);
    }, [projects, projectId]);
}
export function useBoardColumns(projectId) {
    const states = useProjectStates(projectId);
    return states.map((s) => ({ id: s.id, title: s.name }));
}
export function useBoardDragDrop(projectId) {
    const allTasks = useProjectStore((s) => s.tasks);
    const updateTaskStatus = useProjectStore((s) => s.updateTaskStatus);
    const columns = useBoardColumns(projectId);
    const tasks = useMemo(() => (projectId ? allTasks.filter((t) => t.projectId === projectId) : allTasks), [allTasks, projectId]);
    const getTasksByStatus = (status) => tasks.filter((t) => t.status === status);
    const handleTaskMove = (taskId, newStatus) => {
        updateTaskStatus(taskId, newStatus);
    };
    return { tasks, getTasksByStatus, handleTaskMove, columns };
}
//# sourceMappingURL=useBoard.js.map